<template>
  <section id="manuals" data-qa="manual-instructions-section" class="instructions-section">
    <h2>Handleidingen</h2>
    <loader v-if="isLoading" />
    <div v-else>
      <p v-if="!manuals.length">Geen handleidingen beschikbaar.</p>
      <div class="manuals-grid">
        <button
          v-for="manual in manuals"
          :key="manual.id"
          data-qa="manual-tile"
          class="manual-tile"
          @click="openPdf(manual.sasUrl)"
        >
          <span class="manual-tile__icon">&#x1F4C4;</span>
          <span class="manual-tile__title">{{ manual.title }}</span>
        </button>
      </div>
    </div>

    <!-- PDF modal -->
    <div v-if="selectedPdfUrl" class="pdf-modal-overlay" @click.self="closePdf">
      <div class="pdf-modal">
        <div class="pdf-modal-header">
          <button class="pdf-modal-close" @click="closePdf">&#x2715; Sluiten</button>
        </div>
        <iframe :src="selectedPdfUrl" class="pdf-modal-frame" />
      </div>
    </div>
  </section>
</template>

<script>
import ManualsApi from '@/api/server/Manuals.api.js'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'

export default {
  components: { Loader },
  emits: ['onError'],
  data() {
    return {
      manuals: [],
      isLoading: false,
      selectedPdfUrl: null,
    }
  },
  async mounted() {
    this.isLoading = true
    try {
      this.manuals = await ManualsApi.getManuals()
    } catch {
      this.$emit('onError')
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    openPdf(url) {
      this.selectedPdfUrl = url
    },
    closePdf() {
      this.selectedPdfUrl = null
    },
  },
}
</script>

<style lang="scss" scoped>
.manuals-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}

.manual-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.25rem;
  width: 160px;
  background: $gray-lightest;
  border: 1px solid $gray-base;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;

  &:hover {
    background: #dae2e5;
  }

  &__icon {
    font-size: 2rem;
  }

  &__title {
    font-size: 0.85rem;
    color: $gray-darker;
    word-break: break-word;
  }
}

.pdf-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: z-index(modal);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pdf-modal {
  position: relative;
  width: 85vw;
  height: 90vh;
  background: $white;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}

.pdf-modal-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.4rem 0.75rem;
  background: $gray-darker;
  flex-shrink: 0;
}

.pdf-modal-close {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 3px;
  font-size: 0.85rem;
  cursor: pointer;
  color: $white;
  padding: 0.25rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  transition: background-color 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
}

.pdf-modal-frame {
  width: 100%;
  flex: 1;
  border: none;
}
</style>
